export type FeatureFlagId = (typeof featureFlagConst)[keyof typeof featureFlagConst];

export const featureFlagConst = {
    IMPORT_RAW_NARRATION_RECORDING: "importRawNarrationRecording",
    CREATIVE: "creative",
    UPLOAD_NARRATION_CSV: "uploadNarrationFromCSV",
    STORY_LOGIC: "storyLogic",

    CREATIVE_SHOW_UNUSED_CDES_TAB: "creativeShowUnusedCDEsTab",
    OVERVIEW_WITHOUT_OVERVIEW_TAB: "overviewWithoutOverviewTab", // Going to stay with us for a long time
    ADS_REPORT_DE_TO_VIDEOSPEC: "adsReportDeToVideospec",
    USE_OLD_RENDERER_BY_DEFAULT: "useOldRendererByDefault",
    FULL_DEMO_FLOW_BUILDER: "fullDemoFlowBuilder",
    CRM_STORY_VIDEO_RATIO_QUALITY_LOGIC: "crmStoryVideoRatioQualityLogic",
    ADS_STORY_VIDEO_RATIO_QUALITY_DEFINITION: "adsStoryVideoRatioQualityDefinition",
    SSO_FOR_EXTERNAL_USERS: "ssoForExternalUsers",
    INTERNAL_ANALYTICS_EXTEND_TABS: "internalAnalyticsExtendTabs",
    GET_PRESETS_VALUES_SPLIT: "getPresetsValuesSplit",
    REMOVE_REVIEWER_ROLE: "removeReviewerRole",
    // Editor feature flags
    _EDITOR_GENERATE_VIDEO_LINKS_DEMO_FLOW: "_editor generate video links demo flow",
    FORMSTACK_SURVEY_REPORT_CONFIGURATION: "formstack survey report configuration",
    _EDITOR_CREATE_ACCOUNTS_DB_PROGRAM: "_editor create accounts db program",
    _EDITOR_SHOW_MEDIA_TAGS_LAYOUTS: "_editor show media tags layouts",
    _PROMPT_TO_VIDEO: "_prompt to video",
    _EDITOR_SHOW_M2_ANIMATED_WIREFRAMES_ONLY: "_editor show m2 animated wireframes only",
    _EDITOR_REMOVE_ALL_EXTERNAL_USERS_FROM_ACCOUNT: "_editor remove all external users from account", //cannot be deleted because the operation behind is for internal use only
    _EDITOR_ENABLE_ASSET_POST_ASSIGNING: "_editor enable asset post assigning",
    _EDITOR_ENABLE_AI_ON_CUSTOMER_MEDIA: "_editor enable ai on customer media",
    _EDITOR_NEW_VIDEO_PAGE: "_editor new video page",

    _EDITOR_INNOVATION_WEEK_AI_CREATE_IMAGE: "_editor innovation week ai create image",
    _EDITOR_INNOVATION_WEEK_AI_CREATE_IMAGE_USING_GETTY: "_editor innovation week ai create image using getty",
    _EDITOR_INNOVATION_WEEK_REALTIME_NARRATION: "_editor innovation week realtime narration",
    _EDITOR_INNOVATION_WEEK_WHATS_NEXT: "_editor innovation week whats next",
    _EDITOR_INNOVATION_WEEK_PERSONALIZED_PREVIEW: "_editor innovation week personalized preview",
    _EDITOR_INNOVATION_SCENES_TRANSITIONS: "_editor innovation week scenes transitions",
    _EDITOR_EDITABLE_FOLDER_NAME: "_editor editable folder name",
    _EDITOR_EDIT_MEDIA_DIALOG_CROP_FIXES:"_editor edit media dialog crop fixes",
    _EDITOR_BLOCK_DUPLICATING_VIDEOS_USING_OLD_LAYOUTS: "_editor block duplicating videos using old layouts",
    _EDITOR_DRAFT_WATERMARK: "_editor draft watermark",
    _EDITOR_EXPIRE_GETTY_PREMIUM_ASSETS: "_editor expire getty premium assets",
    _EDITOR_BLOCK_EDITING_OLD_LAYOUTS: "_editor block editing old layouts",
    _EDITOR_GENERATE_IMAGE_WITH_AI: "_editor generate image with ai",
    _EDITOR_IMPROVED_ASSET_EDITING: "_editor improved asset editing",
    _EDITOR_AVATARS: "_editor avatars",
    _EDITOR_CUSTOM_AVATARS_CREATE_REAL_AVATAR: "_editor custom avatars create real avatar",
    _EDITOR_WELLSAID_SUNSET_EXPIRED_NOTIFICATIONS: "_editor wellsaid sunset expired notifications",
    _EDITOR_TTS_ADDITIONAL_CONTROLS: "_editor tts additional controls",
    _EDITOR_DELETE_EDITOR_PROGRAM_ALL_VERSIONS: "_editor delete editor program all versions",
    _EDITOR_RECORDING_TOOL: "_editor recording tool",
    _EDITOR_VOICE_CLONING: "_editor voice cloning",
    _EDITOR_CUSTOM_AVATAR_BETA: "_editor custom avatar beta",
    _EDITOR_SAVE_EDITED_MEDIA_TO_LIBRARY: "_editor save edited media to library",
    _EDITOR_ANALYTICS_AND_REPORTS_STATUS: "_editor analytics and reports status",
    _EDITOR_LINEUP_THUMBNAIL_MODIFICATIONS: "_editor lineup thumbnail modifications",
    _EDITOR_AI_WEEK_EDITOR_ASSISTANT: "_editor ai week editor assistant",
    _EDITOR_CONTROL_AI_FEATURES: "_editor control ai features",
    _EDITOR_ENCODER_RECORDER: "_editor encoder recorder",
    _EDITOR_BLANK_CANVAS_SCENE_ACTIONS: "_editor blank canvas scene actions",
    _EDITOR_RECORDER_TOOL_SKIP_PREVIEW_DIALOG: "_editor recorder tool skip preview dialog",
    _EDITOR_REMOVE_PROGRAM_LOGIC: "_editor remove program logic",
    _EDITOR_AI_WEEK_ANIMATE_IMAGE: "_editor ai week animate image",
    _EDITOR_RESPONSIVENESS: "_editor responsiveness",
    _EDITOR_EDIT_AGIF_MP4_IN_IMGLY: "_editor agif mp4 in imgly",
    _EDITOR_CUSTOM_SCENE: "_editor custom scene",
    _EDITOR_ASSET_S3_KEY_BY_ACCOUNT: "_editor asset s3 key by account",
    _EDITOR_DATA_LIBRARY_DUPLICATE_AND_SWITCH: "_editor data library duplicate and switch",
    _EDITOR_NARRATION_DURATION: "_editor narration duration",
    _EDITOR_IMGLY_IMPROVED_ASSET_EDITING_WITH_CANVAS: "_editor improved asset editing with canvas",
    _EDITOR_USE_NEW_UPLOAD_SIZE_LIMITS: "_editor use new upload size limits",
    _EDITOR_NEW_VIDEO_OPTIMIZATION: "_editor new video optimization",
    _EDITOR_PLACE_HOLDER_RICH_TEXT_AI_BUTTON: "_editor place holder rich text ai button",
    _EDITOR_REFACTORED_RECORDING_TOOL: "_editor refactored recording tool",
    _EDITOR_USE_TAVUS_PHOENIX_3_MODEL: "_editor use tavus phoenix-3 model",
    _NO_RAAS_FE_API_KEY_CREATION: "_no raas fe api key creation",
    _CONTRIBUTORS_ENABLED: "_contributors enabled",
    _FLEXIBLE_LAYOUTS_POC: "_flexible layouts POC"
} as const;
